import type { ReactElement } from "react";
import { CmtsTenantPage } from "../../pages/cmtsTenantPage.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(_props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsTenantPage />;
}

export default Component;
